module.exports = __webpack_public_path__ + "img/tow.906dff5c.png";